/* global bootstrap */
import React from 'react'
import Header from './Header'
import {  useNavigate } from 'react-router-dom'
import axios from "axios";
import Swal from 'sweetalert2';
import Moment from 'react-moment';
import config from "../../config"
import { useNetworkState } from 'react-use';
import Footer from './Footer';
import moment from 'moment'
import $ from 'jquery'; 
import 'daterangepicker/daterangepicker.css'; // Import daterangepicker CSS
import 'daterangepicker';
import * as XLSX from 'xlsx'

const Billing_cod_remittance = () => {
  let userDetail = localStorage.getItem('ship_rocket_user');
    // console.log("userDetail====", config.UserId);
    let userData = {};
    if (userDetail != null) {
      userData = JSON.parse(userDetail)
    }
   
    const isOnline = useNetworkState();
    console.log("isONline  === " ,isOnline )
    const[balancestate, setbalanceState ]= React.useState({add_balance:[], total_balance:[] , hold_balance:0})
    const[dimensionState,setdimensionState] = React.useState({companyDetail:[]})
   
    const[transaction  , settransaction] = React.useState([])
    // console.log("transaction == " , transaction)
    const[codremitted , setcodremitted] = React.useState({last_cod_remitted:0 , next_cod_remitted:0 , remittance_due:0, remittance_till:0})

   React.useEffect(()=>{
    get_cod_wallet_balance()
    dimension_detail()
    cod_wallet_transactions()
   },[])

    const get_cod_wallet_balance=()=>{
     let dataToSend = {customer_id : userData.customer_id};
    
      // console.log("datatoSend",dataToSend)
      let url = config.apiUrl + '/user/get_cod_wallet_balance';
      axios.post(url, dataToSend, { headers: config.headers })
          .then((res) => {
            // console.log("responseJson => ", res);
            if(res.data.status==true){
        setbalanceState({add_balance:res.data.added_wallet_transactions, total_balance:res.data.find_customer_wallet , hold_balance:res.data.hold_balance})
     }
    else{
        const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000
          })
          Toast.fire({
            background:"#a61c09",
            type: 'Unsuccess',
            title: "Something Went Wrong !",
            color:"white"
          });
    } })
        
          .catch((error) => {
            const Toast = Swal.mixin({
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000
              })
              Toast.fire({
                background:"#a61c09",
                type: 'Unsuccess',
                title: "Something Went Wrong !",
                color:"white"
              });
              // console.log(error);
          });    
    
    }

   
      
    const dimension_detail = () =>{
        let full_api = config.apiUrl + `/user/get_company_info_api`;
        let sendData = {};
      
        axios.post(full_api, sendData, { headers: config.headers }).then(res => {
          setdimensionState({...dimensionState,companyDetail:res.data.companyDetail});
          // console.log("rnmmmmm", res);
        }).catch((e) => {
          // toast.configure()
           //toast.error("Some thing went wrong")
          // console.log("----error:   ", e);
        })
      }

      const cod_wallet_transactions=()=>{
        let dataToSend = {customer_id : userData.customer_id};
       
         // console.log("datatoSend",dataToSend)
         let url = config.apiUrl + '/shipment/get_cod_wallet_transactions';
         axios.post(url, dataToSend, { headers: config.headers })
             .then((res) => {
               // console.log("responseJson => ", res);
               if(res.data.status==true){
                settransaction(res.data.output)
                setcodremitted({last_cod_remitted: res.data.last_cod_remitted, next_cod_remitted:res.data.next_cod_remitted , remittance_due:res.data.due_remittance , remittance_till:res.data.remittance_till})
        }
       else{
           const Toast = Swal.mixin({
               toast: true,
               position: 'bottom-end',
               showConfirmButton: false,
               timer: 3000
             })
             Toast.fire({
               background:"#a61c09",
               type: 'Unsuccess',
               title: "Something Went Wrong !",
               color:"white"
             });
       } })
           
             .catch((error) => {
               const Toast = Swal.mixin({
                   toast: true,
                   position: 'bottom-end',
                   showConfirmButton: false,
                   timer: 3000
                 })
                 Toast.fire({
                   background:"#a61c09",
                   type: 'Unsuccess',
                   title: "Something Went Wrong !",
                   color:"white"
                 });
                 // console.log(error);
             });    
       
       }

       const handleDownload = () => {
        let excelData = [];
      
        transaction.forEach(sub => {
          if (sub.transactions.length > 0) {
            sub.transactions.forEach(item => {
              excelData.push({
                "Date":new Date(sub.create_date * 1000).toLocaleString(),
                "Payout ID": sub.payout_id,
                "Total Amount": Number(item.total_cod_balance || 0).toFixed(2),
                "Wallet Adjusted": Number(item.wallet_adjusted_amount || 0).toFixed(2),
                "Credit Wallet Adjusted": Number(item.credit_wallet_adjusted_amount || 0).toFixed(2),
                "Early COD Commission": Number(item.early_cod_discount || 0).toFixed(2),
                "Payout Amount": Number(item.payout_amount || 0).toFixed(2),
                "UTR No": item.utr_id || "",
                "Paid Date": item.paid_date || "",
                "Acc No": item.acc_no || "",
                "IFSC Code": item.ifsc_code || "",
                "Status": item.status == 0 ? "Under Process" : "Completed"
              });
            });
          }
        });
      
        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Payout Report");
      
        XLSX.writeFile(workbook, "payout_report.xlsx");
      };
     
     
  return (
    <div>
     <Header/>
 <div class="page-wrapper pinned">
  <div class="main-container">
   <div className='app-container'>
  <div class="app-body">
  <div class="container-fluid"> 
 

<div class="mob_nav">
  <div class="row">
      <div class="col-7">
        <div class=" d-flex justify-content-start ">
          <a href="javascript:window.history.back();" class=""><i class="bi bi-arrow-left"></i></a>
          <h2>COD Remittance (Future COD)</h2>
        </div>
      </div>
      <div class="col">
      </div>
  </div>
</div>


<div class="row justify-content-between desk_nav">
    <div class="col-12 col-md-6 ">
      <div class="d-flex">
        <a href="javascript:window.history.back();" class="back_btn"><i class="bi bi-arrow-90deg-left"></i></a>
        <h2>COD Remittance (Future COD)</h2>
      </div>
    </div>
    <div class="col-12 col-md-4 mb-3">
    </div>
</div>    

{/* <div class="card mb-3">
  <div class="card-body">
    <div class="row justify-content-between">
        <div class="col-12 col-md-6 mb-1">
          <div class="row g-1">
              <div class="col-12 col-md-6">
                <div class="input-group">
                  <input type="text" class="form-control custom-daterange"/>
                  <span class="input-group-text">
                    <i class="bi bi-calendar2-range"></i>
                  </span>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="search-box">
                    <div class="search-icon">
                    <i class="bi bi-search"></i>
                    </div>
                    <input type="text" class="search-input" placeholder="Search ..." onChange={(e)=>setsearchtext(e.target.value)}/>
                </div>
              </div>
          </div>
        </div>
        <div class="col-12 col-md-6 mb-1">
          <div class="row justify-content-between">
              <div class="col-6 col-md">
                <div class="row">
                    <div class="col-12 col-md">
                      <a href="" class="btn btn-outline-secondary btn-block">View Report</a>
                    </div>
                </div>
              </div>
              <div class="col-6 col-md-4 text-end">
                <a  class="btn btn-outline-secondary btn-block" onClick={(e)=>handleDownload(e)}>Download Report</a>
              </div>
          </div>
        </div>
    </div>
  </div>
</div> */}

<section class="mb-3">
          <div class="">
            <div class="card border-0">
              <div class="card-body">
                <div class="row states stboxbil py-3">
                    <div class="col-12 col-md-2 mb-3">
                        <div class="stbox text-center py-4 border rounded  ">
                        {balancestate.total_balance.map((sub)=>( <h5>&#8377;{parseFloat(sub.cod_wallet_balance + balancestate.hold_balance).toFixed(2)}</h5>))}
                        <small>
  COD Collection{" "}
  <i
    className="bi bi-info-circle text-muted ms-1"
    data-bs-toggle="popover"
    data-bs-placement="top"
    data-bs-trigger="hover"
    data-bs-html="true"
    title="COD Collection Info"
    data-bs-content={`<div style='text-align:left;'>
      <strong>Total Available Balance:</strong> ₹${balancestate.total_balance[0]?.cod_wallet_balance?.toFixed(2) || 0}<br/>
      <strong>Hold Balance:</strong> ₹${balancestate.hold_balance?.toFixed(2) || 0}
    </div>`}
    style={{ cursor: "pointer" }}
    onMouseEnter={(e) => {
      const popover = bootstrap.Popover.getOrCreateInstance(e.currentTarget);
      popover.show();
    }}
    onMouseLeave={(e) => {
      const popover = bootstrap.Popover.getInstance(e.currentTarget);
      if (popover) popover.hide();
    }}
  ></i>
</small>
                        </div>
                    </div>
                    <div class="col-12 col-md-2 mb-3">
                        <div class="stbox text-center py-4 border rounded ">
                            <h5>&#8377;{codremitted.remittance_till.toFixed(2)}</h5>
                            <small>Remittance Till Date {" "}
                            <i
  className="bi bi-info-circle text-muted ms-1"
  data-bs-toggle="popover"
  data-bs-placement="top"
  data-bs-trigger="hover"
  data-bs-html="true"
  title="Remittance Till Date"
  data-bs-content={`<div style='text-align:left;'>
    This is the <strong>total remittance amount till date</strong>, including all 
    <strong>wallet</strong> and <strong>credit limit adjustments</strong>.
  </div>`}
  style={{ cursor: "pointer" }}
  onMouseEnter={(e) => {
    const popover = bootstrap.Popover.getOrCreateInstance(e.currentTarget);
    popover.show();
  }}
  onMouseLeave={(e) => {
    const popover = bootstrap.Popover.getInstance(e.currentTarget);
    if (popover) popover.hide();
  }}
></i></small>
                        </div>
                    </div>
                    <div class="col-12 col-md-2 mb-3">
                        <div class="stbox text-center py-4 border rounded ">
                            <h5>&#8377;{codremitted.remittance_due.toFixed(2)}</h5>
                            <small>Remittance Due {" "}
                            <i
  className="bi bi-info-circle text-muted ms-1"
  data-bs-toggle="popover"
  data-bs-placement="top"
  data-bs-trigger="hover"
  data-bs-html="true"
  title="Remittance Due"
  data-bs-content={`<div style='text-align:left;'>
    This is the <strong>remittance amount that is still pending</strong> and 
    <strong>yet to be paid</strong> to your account. It includes all due COD settlements 
    not yet processed.
  </div>`}
  style={{ cursor: "pointer" }}
  onMouseEnter={(e) => {
    const popover = bootstrap.Popover.getOrCreateInstance(e.currentTarget);
    popover.show();
  }}
  onMouseLeave={(e) => {
    const popover = bootstrap.Popover.getInstance(e.currentTarget);
    if (popover) popover.hide();
  }}
></i></small>
                        </div>
                    </div>
                    <div class="col-12 col-md-2 mb-3">
                        <div class="stbox text-center py-4 border rounded ">
                       <h5>&#8377;{Number(codremitted.last_cod_remitted?codremitted.last_cod_remitted.payout_amount?codremitted.last_cod_remitted.payout_amount:0:0).toFixed(2)}</h5>
                            <small>Last Remittance {" "}
                            <i
  className="bi bi-info-circle text-muted ms-1"
  data-bs-toggle="popover"
  data-bs-placement="top"
  data-bs-trigger="hover"
  data-bs-html="true"
  title="Last Remittance"
  data-bs-content={`<div style='text-align:left;'>
      This shows the <strong>last COD remittance amount</strong> that has been 
      <strong>successfully paid</strong> to you.
    </div>`}
  style={{ cursor: "pointer" }}
  onMouseEnter={(e) => {
    const popover = bootstrap.Popover.getOrCreateInstance(e.currentTarget);
    popover.show();
  }}
  onMouseLeave={(e) => {
    const popover = bootstrap.Popover.getInstance(e.currentTarget);
    if (popover) popover.hide();
  }}
></i></small>
                        </div>
                    </div>
                   
                    
                    <div class="col-12 col-md-2 mb-3">
                        <div class="stbox text-center py-4 border rounded ">
                        {/* {codremitted.next_cod_remitted!=0?  <h5>&#8377;{codremitted.next_cod_remitted.toFixed(2)}</h5>:<h5>----</h5>}
                            <small>Next Remittance Due</small> */}
                              <a  class="btn btn-outline-secondary btn-block" onClick={(e)=>handleDownload(e)}>Download Report</a>
                        </div>
                    </div>
                   
                  
                </div>
              </div>
            </div>     
          </div>
        </section>

        <div class="card data_table mb-3 ">
  <div class="card-body">
    <div class="table-responsive" >
      <div class="shipm_tablew rounded-3">
        <table class="table align-top table-striped table-hover m-0 table-xl ">
          <thead>
          <tr>
          <th class="">Date </th>	

                    <th class="">Payout ID #</th>	
                    {/* <th class="border-gray-200">Total COD <a data-bs-toggle="tooltip" title="Total COD Customer Wallet Amount"><i class="bx bx-info-circle"></i></a></th>	 */}
                    <th class="">Total Amount<a data-bs-toggle="tooltip" title="Prepaid Wallet Adjusted from COD Amount"><i class="bx bx-info-circle"></i></a></th>	

                    <th class="">WALLET ADJ. <a data-bs-toggle="tooltip" title="Prepaid Wallet Adjusted from COD Amount"><i class="bx bx-info-circle"></i></a></th>	
                    <th class="">Credit WALLET ADJ. <a data-bs-toggle="tooltip" title="Prepaid Wallet Adjusted from COD Amount"><i class="bx bx-info-circle"></i></a></th>	
                    <th class="">Early COD Commission. <a data-bs-toggle="tooltip" title="Prepaid Wallet Adjusted from COD Amount"><i class="bx bx-info-circle"></i></a></th>
                    <th class="">Payout <a data-bs-toggle="tooltip" title="Total Releasable Payout after adjustment if any"><i class="bx bx-info-circle"></i></a></th>
                    <th class="">UTR #</th>
                    <th class="">Bank Details</th>
                    <th class="">Status</th>
                   
                </tr>
                    </thead>
                    <tbody>
                      

{transaction.map((sub)=>(
                sub.transactions.length>0?
                sub.transactions.map((item)=>(
           
                <tr>
                  <td>
                  <Moment format="MMM DD YYYY">
        {new Date(sub.create_date*1000)}
</Moment>  <Moment format="hh:mm:ss a ">
        {new Date(sub.create_date*1000)}
</Moment>
                  </td>
                    <td>
                       <a className="text-primary" href={`/transaction_detail/${sub.payout_id}`}>{sub.payout_id}</a> 
                    </td>  
                    <td>₹{Number(item.total_cod_balance || 0).toFixed(2)}</td>  

<td className="fw-700 text-danger">
  (-)₹{Number(item.wallet_adjusted_amount || 0).toFixed(2)}<br/>
</td>  

<td className="fw-700 text-danger">
(-)₹{Number(item.credit_wallet_adjusted_amount || 0).toFixed(2)}
</td>  
<td className="fw-700 text-danger">
₹{Number(item.early_cod_discount || 0).toFixed(2)}
</td>  

<td className="fw-700 text-success">
  ₹{Number(item.payout_amount || 0).toFixed(2)}
</td>               
                    <td>
                    <div class="mb-2">
                        {item.utr_id!=""? <>{item.utr_id}<br/>
                  </> : ""}
                       
                    </div>
                    <div>
                        {/* <small>Paid Date</small> */}
                        {item.paid_date!=""?<small>{item.paid_date}</small>:
                        ""}
                    </div>
                    </td>  
                    <td class="">
                   
                   
                    Acc no: {item.acc_no}<br/>
                    IFSC Code: {item.ifsc_code}<br/>
                   
                    
                    </td>
                    <td>
                   {item.status==0?     <span class="badge bg-warning"> <i class="fa fa-clock-o" aria-hidden="true"></i> Under Process</span>: <span class="badge bg-success"> <i class="fa fa-check" aria-hidden="true"></i> Completed</span>}
                    </td>
                </tr>
              
            
          )):""
            ))}
                     
                      {/* <tr>
                        <td colspan="12" class="text-center">
                          <p>Your remittance is on its way</p>
                          <small>We release COD remittance 3 times in a week and on the 8th day from the date of delivery.</small>
                        </td>
                      </tr> */}
                    </tbody>
                </table>  
               
      </div>
    </div>
  </div>
</div>
</div></div>
<Footer/></div></div></div>
    </div>
        
    

 
   
    
  )
}

export default Billing_cod_remittance
